import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { GlobalConstants } from '../../../../../../../../../src/app/common/constants/global.constant';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { OemService } from '../../../../../../../core/routing/services/oem/oem.service';
import { Content } from '../../../../../../oem-portal/interface/oem-portal-interface.i';
import { OemConstants } from 'src/app/core/routing/services/oem/constants/oem.constants';

@Component({
  selector: 'iposcen-view-pages',
  templateUrl: './view-pages.component.html',
  styleUrls: ['./view-pages.component.scss']
})
export class ViewPagesComponent implements OnInit, OnDestroy {
  @Input() configData: any;
  multiPageconfig: any;
  contentData: any;
  configurations: any;
  singlePageConfig: any;
  videoPageConfig: any;
  bodyLabel = OemConstants.BODY;
  bodyHeading = OemConstants.HEADING;
  bodyLabelB = OemConstants.BODYB;
  bodyLabelA = OemConstants.BODYA;
  headingLabel = 'Heading';
  imageUrl: string;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private oemservice: OemService) { }
  ngOnInit(): void {
    this.contentData = this.configData[0];
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();

  }

  fontSize(size) {
    if (size == 12) {
      return GlobalConstants.FONTSIZE_12PX;
    }
    if (size == 14) {
      return GlobalConstants.FONTSIZE_14PX;
    }
    if (size == 16) {
      return GlobalConstants.FONTSIZE_16PX;
    }
  }

  getUILayoutIDByName(name) {// TODO - Confirm with Sujay if layout name is correct
    if (name === '3-asset-layout') {
      return 1;
    } else if (name === '1-image-layout') {
      return 2;
    } else if (name === '1-video-layout') {
      return 3;
    }
  }
}
